'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dItem$002dSelector from "./presto.-Item-Selector.js";
import * as $j_presto$002e$002dSignals$0024 from "./presto.-Signals$.js";
import * as $j_presto$002eui$002e$002dInputs$0024 from "./presto.ui.-Inputs$.js";
import * as $j_presto$002eui$002e$002dInputs$0024$0024anon$00247 from "./presto.ui.-Inputs$$anon$7.js";
import * as $j_presto$002eui$002e$002dInputs$0024$002dInput$002dVar$0024 from "./presto.ui.-Inputs$-Input-Var$.js";
import * as $j_presto$002eui$002eextensions$0024 from "./presto.ui.extensions$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialSelector(items, selected, changes) {
  this.WP = null;
  this.WQ = null;
  this.WO = null;
  this.aDB = null;
  this.WP = items;
  this.WQ = selected;
  this.WO = changes;
  var name = $j_presto$002eui$002e$002dInputs$0024$002dInput$002dVar$0024.$m_Lpresto_ui_Inputs$InputVar$().ay($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$().cV());
  var username = $j_presto$002eui$002e$002dInputs$0024$002dInput$002dVar$0024.$m_Lpresto_ui_Inputs$InputVar$().ay($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$().cV());
  var $x_5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$();
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$();
  var $x_3 = $j_presto$002eui$002eextensions$0024.$m_Lpresto_ui_extensions$();
  var this$3 = $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$();
  var $x_2 = $x_3.aS(new $j_presto$002eui$002e$002dInputs$0024$0024anon$00247.$c_Lpresto_ui_Inputs$$anon$7("Nome", name, $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$().bi(), $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$().bo(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), this$3));
  var $x_1 = $j_presto$002eui$002eextensions$0024.$m_Lpresto_ui_extensions$();
  var this$4 = $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$();
  var inputs = $x_5.ag($x_4.c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.r().C)([$x_2, $x_1.aS(new $j_presto$002eui$002e$002dInputs$0024$0024anon$00247.$c_Lpresto_ui_Inputs$$anon$7("Usu\u00e1rio", username, $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$().bi(), $j_presto$002eui$002e$002dInputs$0024.$m_Lpresto_ui_Inputs$().bo(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), this$4))])));
  var filtered = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapSignal(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_presto$002e$002dSignals$0024.$m_Lpresto_Signals$().kr(name.bq(), username.bq(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction2(((x$1, x$2) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var x252 = x$1.T;
      if ((x252 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var uname = x252.a0;
        if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var x248 = x$2.T;
          if ((x248 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
            var n = x248.a0;
            return items.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it) => {
              var this$7 = it.lI;
              var this$8 = this$7.fy;
              if (((this$8.indexOf(n) | 0) !== (-1))) {
                var this$10 = it.lI;
                var this$11 = this$10.kX;
                return ((this$11.indexOf(uname) | 0) !== (-1));
              } else {
                return false;
              }
            })));
          }
        }
      }
      if ((($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x252) && (x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success))) {
        var x240 = x$2.T;
        if ((x240 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
          var n$3 = x240.a0;
          return items.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it$2) => {
            var this$13 = it$2.lI;
            var this$14 = this$13.fy;
            return ((this$14.indexOf(n$3) | 0) !== (-1));
          })));
        }
      }
      if ((x252 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var uname$3 = x252.a0;
        if (((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success) && ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x$2.T))) {
          return items.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it$3) => {
            var this$16 = it$3.lI;
            var this$17 = this$16.kX;
            return ((this$17.indexOf(uname$3) | 0) !== (-1));
          })));
        }
      }
    }
    return items;
  })))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$96) => _$96.a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$97) => _$97.lI))))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
  this.aDB = new $j_presto$002e$002dItem$002dSelector.$c_Lpresto_ItemSelector(items, selected, changes, filtered, inputs);
}
export { $c_Lpresto_CredentialSelector as $c_Lpresto_CredentialSelector };
$p = $c_Lpresto_CredentialSelector.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialSelector;
/** @constructor */
function $h_Lpresto_CredentialSelector() {
}
export { $h_Lpresto_CredentialSelector as $h_Lpresto_CredentialSelector };
$h_Lpresto_CredentialSelector.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_CredentialSelector)) {
    var x = this.WP;
    var x$2 = x$0.WP;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.WQ;
      var x$4 = x$0.WQ;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.WO;
      var x$6 = x$0.WO;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "CredentialSelector";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.WP;
      break;
    }
    case 1: {
      return this.WQ;
      break;
    }
    case 2: {
      return this.WO;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_CredentialSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hW)));
}
export { $isArrayOf_Lpresto_CredentialSelector as $isArrayOf_Lpresto_CredentialSelector };
var $d_Lpresto_CredentialSelector = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialSelector, "presto.CredentialSelector", ({
  hW: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_CredentialSelector as $d_Lpresto_CredentialSelector };
//# sourceMappingURL=presto.-Credential-Selector.js.map
